import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { NetstaffLogo } from "@/components/NetstaffLogo";
import {
  LayoutDashboard, FileText, Trello, Users, Map, Receipt, AlertTriangle,
  ScrollText, LogOut, Sparkles,
} from "lucide-react";

const nav = [
  { to: "/dispatch", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/dispatch/requests", icon: FileText, label: "Requests" },
  { to: "/dispatch/board", icon: Trello, label: "Dispatch Board" },
  { to: "/dispatch/professionals", icon: Users, label: "Professionals" },
  { to: "/dispatch/map", icon: Map, label: "Map Match" },
  { to: "/dispatch/invoices", icon: Receipt, label: "Invoices" },
  { to: "/dispatch/incidents", icon: AlertTriangle, label: "Incidents" },
  { to: "/dispatch/services", icon: Sparkles, label: "Services" },
  { to: "/dispatch/audit", icon: ScrollText, label: "Audit Log" },
];

export default function DispatcherLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex bg-slate-50">
      <aside className="dispatch-sidebar w-64 hidden md:flex flex-col text-white sticky top-0 h-screen">
        <div className="p-6 border-b border-white/10">
          <Link to="/dispatch" className="flex items-center gap-3">
            <img src="https://customer-assets.emergentagent.com/job_5b507e1c-bf44-420e-878d-cde61c04be26/artifacts/0mj0i30f_100684b4-2ee5-49d4-b617-8020dd03666a.jpg" className="h-9 w-9 rounded-lg" alt="logo" />
            <div className="leading-none">
              <div className="font-bold text-xl" style={{ fontFamily: "Outfit, sans-serif" }}>NetStaff</div>
              <div className="text-[10px] uppercase tracking-[0.15em] text-white/60 mt-0.5">Dispatch Console</div>
            </div>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {nav.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`dispatch-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive ? "bg-white text-brand-navy" : "text-white/80 hover:bg-white/10"
                  }`
                }
              >
                <Icon className="w-4 h-4" />{n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="text-sm font-semibold">{user?.name}</div>
          <div className="text-xs text-white/60">{user?.role === "super_admin" ? "Super Admin" : "Dispatcher"}</div>
          <button onClick={() => { logout(); navigate("/"); }} className="mt-3 text-xs flex items-center gap-2 text-white/70 hover:text-white" data-testid="dispatch-logout-btn">
            <LogOut className="w-3 h-3" />Sign out
          </button>
        </div>
      </aside>

      {/* Mobile top nav */}
      <div className="md:hidden w-full bg-brand-navy text-white p-3 flex items-center justify-between fixed top-0 z-50">
        <NetstaffLogo showText={false} className="h-8 w-8" />
        <button onClick={() => { logout(); navigate("/"); }}><LogOut className="w-5 h-5" /></button>
      </div>

      <main className="flex-1 p-6 md:p-8 pt-20 md:pt-8 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
